import { createActions } from 'redux-actions';

import { ENDPOINTS_USER } from '../../config/';
import {
  BaseAchievementElement,
  BaseAchievementElementsIO,
} from '../../reducers/ProfileReducer/AchievementsReducer/AchievementsReducer.types';
import { defaultErrorMessage, globalFetch, ioTsValidationError, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';
import { fetchUserOptions } from '../AccountActions/AccountActions';

export const {
  achievementsResponse,
  changeAchievementsFilter,
  profileResponse,
  achievementsRequest,
  achievementsResponseFailure,
  profileRequest,
  profileResponseFailure,
} = createActions(
  {
    ACHIEVEMENTS_RESPONSE: (data: BaseAchievementElement[]) => ({ data }),
    CHANGE_ACHIEVEMENTS_FILTER: filter => filter,
    PROFILE_RESPONSE: (data: BaseAchievementElement[]) => ({ data }),
  },
  'ACHIEVEMENTS_REQUEST',
  'ACHIEVEMENTS_RESPONSE_FAILURE',
  'PROFILE_REQUEST',
  'PROFILE_RESPONSE_FAILURE'
);

export function getUserProfile(userId: string) {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['profile', 'publicProfile', 'isFetching']) || userId === undefined) {
      return Promise.resolve({});
    }
    dispatch(profileRequest());
    setTimeout(() => dispatch(fetchUserOptions()), 0);

    return globalFetch(
      `${ENDPOINTS_USER.user}/${userId}/profile`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(profileResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'PROFILE_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(profileResponse(json));
        }
      })
      .catch((err: any) => {
        defaultErrorMessage(dispatch);
        logErrorService(err, err);

        return dispatch(profileResponseFailure());
      });
  };
}

export function getUserAchievements(userId: string) {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['profile', 'achievements', 'isfetching']) === true || userId === undefined) {
      return Promise.resolve({});
    }
    dispatch(achievementsRequest());

    return globalFetch(
      `${ENDPOINTS_USER.user}/${userId}/achievements`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(achievementsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'ACHIEVEMENTS_RESPONSE_FAILURE')) {
          return json;
        } else if (BaseAchievementElementsIO.decode(json).isRight()) {
          return dispatch(achievementsResponse(json));
        } else {
          // It will be reported to sentry the io-ts validation errors
          ioTsValidationError(json, BaseAchievementElementsIO);

          return dispatch(achievementsResponseFailure());
        }
      })
      .catch((err: any) => {
        defaultErrorMessage(dispatch);
        logErrorService(err, err);

        return dispatch(achievementsResponseFailure());
      });
  };
}
